"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectiveDeviceConfig = exports.DeviceConfigValues = exports.LogLevels = exports.Orientations = exports.UpdateChannels = void 0;
const zod_1 = require("zod");
exports.UpdateChannels = ['stable', 'beta'];
// `landscape`/`portrait` lock the screen; `auto` follows the device's
// installed (mounted) orientation without live flipping; `sensor` follows the
// accelerometer in real time — for displays that physically rotate. When
// unset, the player follows the screen (see PlayerActivity.orientationToActivityInfo).
exports.Orientations = ['landscape', 'portrait', 'auto', 'sensor'];
exports.LogLevels = ['info', 'debug'];
exports.DeviceConfigValues = zod_1.z.object({
    server_url: zod_1.z.string().url().optional(),
    update_channel: zod_1.z.enum(exports.UpdateChannels).optional(),
    orientation: zod_1.z.enum(exports.Orientations).optional(),
    volume_pct: zod_1.z.number().int().min(0).max(100).optional(),
    daily_reboot_at: zod_1.z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).nullable().optional(),
    heartbeat_interval_s: zod_1.z.number().int().min(15).max(3600).optional(),
    kiosk_exit_pin: zod_1.z.string().min(4).max(12).optional(),
    log_level: zod_1.z.enum(exports.LogLevels).optional(),
});
exports.EffectiveDeviceConfig = zod_1.z.object({
    config_version: zod_1.z.number().int().nonnegative(),
    values: exports.DeviceConfigValues,
});
//# sourceMappingURL=device-config.schema.js.map